import { Modal } from "@heroui/modal";
import { CreateAccountForFreeModalContent } from "./CreateAccountForFreeModalContent";
import { AppLevelModalType } from "~/types/general";
import { SignInToLikeResponseModalContent } from "./SignInToLikeResponseModalContent";
import { SignInToBookmarkResponseModalContent } from "./SignInToBookmarkResponseModalContent";
import { PaywallModalContent } from "./PaywallModalContent";

export const AppLevelModal = ({
  modal,
  isOpen,
  onOpenChange,
}: {
  modal: AppLevelModalType;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      backdrop="blur"
      scrollBehavior="inside"
      className="max-w-2xl"
      size={modal === AppLevelModalType.Paywall ? "full" : "md"}
    >
      {modal === AppLevelModalType.CreateAccountForFree && (
        <CreateAccountForFreeModalContent />
      )}
      {modal === AppLevelModalType.SignInToLikeResponse && (
        <SignInToLikeResponseModalContent />
      )}
      {modal === AppLevelModalType.SignInToBookmarkResponse && (
        <SignInToBookmarkResponseModalContent />
      )}
      {modal === AppLevelModalType.Paywall && <PaywallModalContent />}
    </Modal>
  );
};
